/** Same-origin API prefix (Vite/nginx proxy). Use for OIDC redirects and public fetches. */
export function apiProxyOrigin(): string {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`
  }
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim()
  if (!raw) return '/api'
  const normalized = raw.replace(/\/$/, '')
  if (/\/api\/v\d+$/i.test(normalized)) return normalized.replace(/\/v\d+$/i, '')
  if (/\/api$/i.test(normalized)) return normalized
  return `${normalized}/api`
}

/** Browser API base — always same-origin so whitelabel CSP (connect-src 'self') works. */
export function resolveApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    return apiProxyOrigin()
  }
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim()
  if (raw) return raw.replace(/\/$/, '')
  return apiProxyOrigin()
}

export function apiProxyUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${apiProxyOrigin()}${p}`
}
